module.exports = __webpack_public_path__ + "img/create_test.38d62e85.gif";